// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .chatbot-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-left: 1px solid #ddd;
  max-width: 100%;
  border-radius: 12px 0 0 12px;
  box-shadow: -8px 0 20px rgba(0, 0, 0, 0.1);
}


.chatbot-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ccc;
}

.chatbot-header-left,
.chatbot-header-right {
  display: flex;
  align-items: center;
}

.start-new-chat-btn {
  background-color: #4a90e2;
  color: white;
  border: none;
  padding: 6px 12px;
  font-weight: 500;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
}

.start-new-chat-btn:hover {
  background: #2d6dc6;
  transform: translateY(-1px);
}

.close-chat-btn {
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 4px;
  color: #555;
}

.close-chat-btn:hover {
  color: #333;
}

.close-chat-btn:hover {
  color: #000;
}

.chatbot-body {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background: linear-gradient(to top, #fafafa, #ffffff);
  
  
}

.chat-message {
  max-width: 90%;
  margin: 12px auto;
  padding: 10px 14px;
  border-radius: 16px;
  line-height: 1.5;
  font-size: 15px;
  animation: fadeIn 0.3s ease-in;
}

.user-message {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 8px;
  margin: 8px 16px;
  background-color: var(--user-message-background);
  border-radius: 18px;
  padding: 0px 15px;
}

.user-message .chat-bubble-content {
  background-color: #ffffff;
  border-radius: 18px;
  padding: 0px 15px;
  border-bottom-right-radius: 4px;
  max-width: 70%;
  word-wrap: break-word;
  font-size: 15px;
  line-height: 1.4;
}

 

.assistant-message {
  background-color: transparent;
  align-self: flex-start;
  border-bottom-left-radius: 4px;
  max-width: 110%;
  padding: 10px;
  margin-bottom: 10px;
  width: 95%;
}

.assistant-icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
 
.assistant-text {
  color: var(--text-color);
  max-width: 100%;
  padding: 10px;
  font-family: 'Inter', Arial, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  width: 100%;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(5px); }
  to   { opacity: 1; transform: translateY(0); }
}

.input-area-container {
  display: flex;
  align-items: center;
  padding: 12px;
  border-top: 1px solid #eee;
  background: #fff;
}

.input-area-container input {
  flex-grow: 1;
  padding: 10px 14px;
  border: 1px solid #ddd;
  border-radius: 24px;
  outline: none;
  font-size: 14px;
  transition: all 0.2s ease;
}

.input-area-container input:focus {
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.1);
}

.send-button {
  position: absolute;
  right: 45px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chatbot-model-container {
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.chatbot-model-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-color);
}

.chatbot-model-icon {
  height: 45px;
  width: auto;
  object-fit: contain;
} 








`, "",{"version":3,"sources":["webpack://./src/components/styles/Chatbot.css"],"names":[],"mappings":"CAAC;EACC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,4BAA4B;EAC5B,0CAA0C;AAC5C;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,qDAAqD;;;AAGvD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,gDAAgD;EAChD,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;;;AAIA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[" .chatbot-wrapper {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: #fff;\r\n  border-left: 1px solid #ddd;\r\n  max-width: 100%;\r\n  border-radius: 12px 0 0 12px;\r\n  box-shadow: -8px 0 20px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n\r\n.chatbot-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 8px 12px;\r\n  background-color: #f5f5f5;\r\n  border-bottom: 1px solid #ccc;\r\n}\r\n\r\n.chatbot-header-left,\r\n.chatbot-header-right {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.start-new-chat-btn {\r\n  background-color: #4a90e2;\r\n  color: white;\r\n  border: none;\r\n  padding: 6px 12px;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.start-new-chat-btn:hover {\r\n  background: #2d6dc6;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.close-chat-btn {\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  padding: 4px;\r\n  color: #555;\r\n}\r\n\r\n.close-chat-btn:hover {\r\n  color: #333;\r\n}\r\n\r\n.close-chat-btn:hover {\r\n  color: #000;\r\n}\r\n\r\n.chatbot-body {\r\n  flex-grow: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: auto;\r\n  background: linear-gradient(to top, #fafafa, #ffffff);\r\n  \r\n  \r\n}\r\n\r\n.chat-message {\r\n  max-width: 90%;\r\n  margin: 12px auto;\r\n  padding: 10px 14px;\r\n  border-radius: 16px;\r\n  line-height: 1.5;\r\n  font-size: 15px;\r\n  animation: fadeIn 0.3s ease-in;\r\n}\r\n\r\n.user-message {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: flex-end;\r\n  gap: 8px;\r\n  margin: 8px 16px;\r\n  background-color: var(--user-message-background);\r\n  border-radius: 18px;\r\n  padding: 0px 15px;\r\n}\r\n\r\n.user-message .chat-bubble-content {\r\n  background-color: #ffffff;\r\n  border-radius: 18px;\r\n  padding: 0px 15px;\r\n  border-bottom-right-radius: 4px;\r\n  max-width: 70%;\r\n  word-wrap: break-word;\r\n  font-size: 15px;\r\n  line-height: 1.4;\r\n}\r\n\r\n \r\n\r\n.assistant-message {\r\n  background-color: transparent;\r\n  align-self: flex-start;\r\n  border-bottom-left-radius: 4px;\r\n  max-width: 110%;\r\n  padding: 10px;\r\n  margin-bottom: 10px;\r\n  width: 95%;\r\n}\r\n\r\n.assistant-icon {\r\n  width: 30px;\r\n  height: 30px;\r\n  margin-right: 10px;\r\n}\r\n \r\n.assistant-text {\r\n  color: var(--text-color);\r\n  max-width: 100%;\r\n  padding: 10px;\r\n  font-family: 'Inter', Arial, sans-serif;\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n  width: 100%;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; transform: translateY(5px); }\r\n  to   { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n.input-area-container {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 12px;\r\n  border-top: 1px solid #eee;\r\n  background: #fff;\r\n}\r\n\r\n.input-area-container input {\r\n  flex-grow: 1;\r\n  padding: 10px 14px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 24px;\r\n  outline: none;\r\n  font-size: 14px;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.input-area-container input:focus {\r\n  border-color: #4a90e2;\r\n  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.1);\r\n}\r\n\r\n.send-button {\r\n  position: absolute;\r\n  right: 45px;\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.chatbot-model-container {\r\n  margin-top: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n}\r\n\r\n.chatbot-model-label {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: var(--text-color);\r\n}\r\n\r\n.chatbot-model-icon {\r\n  height: 45px;\r\n  width: auto;\r\n  object-fit: contain;\r\n} \r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
